module.exports = __webpack_public_path__ + "media/images/amenities_icons/meditation-3567654301f94f454ea2166295505d22.svg";